import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!

  return (_openBlock(), _createBlock(_component_q_icon, { size: _ctx.size }, {
    default: _withCtx(() => _cache[0] || (_cache[0] = [
      _createElementVNode("svg", {
        version: "1.1",
        id: "Ebene_1",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 32 32",
        "enable-background": "new 0 0 32 32",
        "xml:space": "preserve"
      }, [
        _createElementVNode("g", null, [
          _createElementVNode("path", { d: "M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14S23.7,2,16,2z M16,28C9.4,28,4,22.6,4,16S9.4,4,16,4s12,5.4,12,12\n          S22.6,28,16,28z" }),
          _createElementVNode("polygon", { points: "17,15 17,7 15,7 15,15 7,15 7,17 15,17 15,25 17,25 17,17 25,17 25,15 \t" })
        ])
      ], -1)
    ])),
    _: 1
  }, 8, ["size"]))
}